import { render, staticRenderFns } from "./EmployeesByCutOff.vue?vue&type=template&id=4c1396a1"
import script from "./EmployeesByCutOff.vue?vue&type=script&lang=js"
export * from "./EmployeesByCutOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports